import { Component, ElementRef, OnInit } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject, take, takeUntil } from 'rxjs';
import { AddOrEditSubcategoryModel } from 'src/app/pos-panel/models/subcategories/add-or-edit-subcategory.model';
import { CategoryModel } from "../../../models/categories/category.model";
import { MenuService } from "../../../services/menus/menu.service";
import { MessageService } from "primeng/api";
import {
  CropAndCompressImageDialogComponent
} from "../../../../share-modul/components/crop-and-compress-image-dialog/crop-and-compress-image-dialog.component";
import { CroppedImage } from "../../../../share-modul/models/image/cropped-image.model";

@Component({
  selector: 'app-add-or-edit-subcategory',
  templateUrl: './add-or-edit-subcategory.component.html',
  styleUrls: ['./add-or-edit-subcategory.component.scss']
})
export class AddOrEditSubcategoryComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public pictureIsWrongFormat: boolean = false;
  public addOrEditSubcategoryModel: AddOrEditSubcategoryModel = new AddOrEditSubcategoryModel();
  public filePicture: any;
  public pictureFormat: Array<string>;
  public imagePath: string = './assets/images/logo/category.png';
  public errorModel: { [k: string]: any } = {};
  public spinner: boolean = false;
  public enableEdit: boolean = false;
  public subcategoryId: string;
  public categoriesDropdownHelperModels: Array<CategoryModel> = new Array<CategoryModel>();
  public companyId: string;
  public requiredFieldErrorMessage = "INFO.REQUIRED_FIELD";
  //#endregion

  //#region Constructor
  constructor(
    private openFile: ElementRef,
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private messageService: MessageService,
    private menuService: MenuService,
    public dialogService: DialogService
  ) {
    this.pictureFormat = ['image/png', 'image/jpg', 'image/jpeg'];
    if (this.config.data != undefined && this.config.data.subcategory) {
      this.subcategoryId = this.config.data.subcategory.id;
      this.enableEdit = true;
      this.addOrEditSubcategoryModel = JSON.parse(JSON.stringify(this.config.data.subcategory));
    }
    if (this.config.data != undefined && this.config.data.companyId) {
      this.companyId = this.config.data.companyId;
    }
  }

  ngOnInit(): void {
    this.loadCategoriesForCompany();
  }

  //#endregion
  //#region Public Methods
  addSubcategory(model: AddOrEditSubcategoryModel) {
    this.errorModel = {};
    model.languageId = this.languageIdFromLocalStorage().toString();
    model.companyId = this.companyId;

    if (model && (!model.name || model.name == "")) {
      this.errorModel['Name'] = this.requiredFieldErrorMessage;
    }
    if (model && (!model.parentId || model.parentId == "")) {
      this.errorModel['ParentId'] = this.requiredFieldErrorMessage;
    }
    if (!this.filePicture) {
      this.errorModel['Image'] = this.requiredFieldErrorMessage;
    }

    if (!this.errorModel['Name'] && !this.errorModel['Image'] && !this.errorModel['ParentId']) {
      if(model.description != null) {
        model.description = model.description.replace(/\n/g, ' ');
      }
      this.spinner = true;

      this.menuService.createSubcategory(model, this.filePicture)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            this.spinner = false;
            this.ref.close(true)
          },
          error: errorResponse => {
            this.spinner = false;
            this.messageService.add({severity: 'error', summary: "System error", life: 2000});
          }
        });
    }
  }

  editSubcategory(model: AddOrEditSubcategoryModel) {
    this.errorModel = {};
    model.languageId = this.languageIdFromLocalStorage().toString();
    model.companyId = this.companyId;

    if (model && (!model.name || model.name == "")) {
      this.errorModel['Name'] = this.requiredFieldErrorMessage;
    }
    if (model && (!model.parentId || model.parentId == "")) {
      this.errorModel['ParentId'] = this.requiredFieldErrorMessage;
    }
    if (!this.filePicture && (!model.pictureURL || model.pictureURL == "")) {
      this.errorModel['Image'] = this.requiredFieldErrorMessage;
    }

    if (!this.errorModel['Name'] && !this.errorModel['Image'] && !this.errorModel['ParentId']) {
      if(model.description != null) {
        model.description = model.description.replace(/\n/g, ' ');
      }
      this.spinner = true;

      this.menuService.updateSubcategory(model, this.filePicture)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            this.spinner = false;
            this.ref.close(true)
          },
          error: errorResponse => {
            this.spinner = false;
            this.messageService.add({severity: 'error', summary: "System error", life: 2000});
          }
        });
    }
  }

  loadCategoriesForCompany() {
    this.spinner = true;
    this.menuService.listCategoryForCompany(this.companyId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          this.categoriesDropdownHelperModels = response;
        },
        error: errorResponse => {
          this.spinner = false;
        }
      });
  }

  determineImageUrl(pictureUrl: string) {
    const image = pictureUrl ? pictureUrl : this.imagePath;
    return encodeURI(image);
  }

  languageIdFromLocalStorage(): number {
    const langIdFromStorage = localStorage.getItem('languageId');

    if (langIdFromStorage) {
      return parseInt(langIdFromStorage);
    } else {
      return 1;
    }
  }

  cropAndCompressImageDialog(): void {
    const ref = this.dialogService.open(CropAndCompressImageDialogComponent, {
      data: {
        imagePath: this.imagePath
      },
      styleClass: 'dialog_long, mb_5, ml_200, dialog_menuItems_cropper'
    });
    ref.onClose.subscribe((image: CroppedImage) => {
      if (image) {
        this.filePicture = image.imageFile;
        this.addOrEditSubcategoryModel.pictureURL = image.imagePath;
      }
    });
  }
  //#endregion
}
